export default "__VITE_ASSET__D_TXh9I4__"